import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
  colors: {
    gray: {
      700: '#1f2733',
    },
    navy: {
      50: '#d0dcfb',
      100: '#aac0fe',
      200: '#a3b9f8',
      300: '#728fea',
      400: '#3652ba',
      500: '#1b3bbb',
      600: '#24388a',
      700: '#1b254b',
      800: '#111c44',
      900: '#0b1437',
    },
    // Semantic brand scale (indigo — premium, elegant, Linear-inspired)
    brand: {
      50:  '#EEF2FF',
      100: '#E0E7FF',
      200: '#C7D2FE',
      300: '#A5B4FC',
      400: '#818CF8',
      500: '#6366F1',
      600: '#4F46E5',
      700: '#4338CA',
      800: '#3730A3',
      900: '#312E81',
    },
    // Surface tokens — neutral zinc palette, clean professional
    surface: {
      base:    '#FFFFFF',
      raised:  '#FFFFFF',
      sunken:  '#F4F4F5',
      overlay: 'rgba(0,0,0,0.40)',
    },
    // Semantic text tokens — slate-based for softer feel vs pure black
    text: {
      primary:   '#1F2937',
      secondary: '#4B5563',
      muted:     '#9CA3AF',
      inverse:   '#FFFFFF',
    },
    // Status colors — distinct hues from brand indigo
    status: {
      success: '#10B981',  // emerald-500
      warning: '#F59E0B',  // amber-500
      error:   '#EF4444',  // red-500
      info:    '#0EA5E9',  // sky-500
    },
  },
  styles: {
    global: props => ({
      body: {
        overflowX: 'hidden',
        bg: mode('#F1F5F9', '#0B1437')(props),
        fontFamily:
          "'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
        color: mode('text.primary', 'whiteAlpha.900')(props),
        lineHeight: '1.65',
      },
      html: {
        fontFamily:
          "'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
        fontSize: '14px',
        textRendering: 'optimizeLegibility',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
      // Shimmer keyframe cho skeleton loading
      '@keyframes shimmer': {
        '0%': { backgroundPosition: '-600px 0' },
        '100%': { backgroundPosition: '600px 0' },
      },
      // Page route transition — fade up on mount
      '@keyframes routeFadeUp': {
        '0%':   { opacity: 0, transform: 'translateY(8px)' },
        '100%': { opacity: 1, transform: 'translateY(0)' },
      },
      '.route-enter': {
        animation: 'routeFadeUp 0.28s cubic-bezier(0.4, 0, 0.2, 1) forwards',
      },
    }),
  },
};
